import React, { useEffect, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import SoftBadge from "modules/common/SoftBadge";
import Loader from "modules/Loader";
import { getFormattedDate } from "modules/utilities/utility";

function OrderManagementTable({ orders, isLoading, setCheckedItems }) {
  const [allFlag, setAllFlag] = useState(false);
  const [tableData, setTableData] = useState(orders?.orders);

  useEffect(() => {
    setTableData(orders?.orders);
  }, [orders]);

  const handleChange = (event, itemId) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setTableData((prevData) =>
        prevData?.map((item) =>
          item?.id === itemId ? { ...item, checked: true } : item
        )
      );
      setCheckedItems((prevCheckedItems) => [...prevCheckedItems, itemId]);
    } else {
      setTableData((prevData) =>
        prevData?.map((item) =>
          item.id === itemId ? { ...item, checked: false } : item
        )
      );
      setCheckedItems((prevCheckedItems) =>
        prevCheckedItems.filter((id) => id !== itemId)
      );
    }
  };

  const handleAllChange = (event) => {
    if (event.target.checked) {
      const allIds = tableData?.map((item) => item.id) || [];
      setTableData((prevData) =>
        prevData?.map((item) => ({ ...item, checked: true }))
      );
      setCheckedItems(allIds);
      setAllFlag(true);
    } else {
      setCheckedItems([]);
      setAllFlag(false);
      setTableData((prevData) =>
        prevData?.map((item) => ({ ...item, checked: false }))
      );
    }
  };

  return (
    <div className="">
      <div className="card">
        <div className="card-body d-flex flex-column">
          <table className="d-flex flex-column mt-1  rounded table-hover">
            <thead
              className="d-flex text-gray border rounded-top "
              style={{ backgroundColor: "#F9FAFD" }}
            >
              <th className="flex-1 fw-bold text-black p-1 mt-1">
                <div className="form-check">
                  <OverlayTrigger
                    overlay={
                      <Tooltip
                        style={{ position: "fixed" }}
                        id="overlay-trigger-example"
                      >
                        <div className="fw-bold">Select All</div>
                      </Tooltip>
                    }
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckIndeterminate"
                      onChange={handleAllChange}
                      checked={allFlag ? true : false}
                      style={{ content: "-" }}
                    />
                  </OverlayTrigger>
                  <label
                    className="form-check-label fw-bold"
                    htmlFor="flexCheckIndeterminate"
                  >
                    Order Display Id
                  </label>
                </div>
              </th>
              <th
                className="flex-1 fw-bold text-secondary text-black mt-1 py-1 "
                style={{ flex: "0.8" }}
              >
                Status
              </th>
              <th
                className="flex-1 fw-bold text-secondary text-black mt-1 text-center px-3 py-1"
                style={{ flex: "1" }}
              >
                Order Date
              </th>
            </thead>
            <div
              style={{
                height: "20vh",
                maxHeight: "30vh",
                overflowY: "scroll",
              }}
              className="scrollable-container"
            >
              {isLoading ? (
                <div className="position-absolute mt-5 start-50 translate-middle">
                  <Loader />{" "}
                </div>
              ) : tableData ? (
                tableData?.map((item, index) => {
                  return (
                    <tr
                      id="table-row-value"
                      key={item?.id}
                      className={
                        item.checked
                          ? `flex-1 py-2  d-flex justify-content-between selected-table-row border-collapse${
                              index === tableData.length - 1 && `rounded-bottom`
                            }`
                          : `flex-1 py-2  d-flex justify-content-between border-collapse ${
                              index === tableData.length - 1 && `rounded-bottom`
                            }`
                      }
                    >
                      <td className="flex-1 text-left p-1  text-break text-primary cursor-pointer fw-bold">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={item?._id}
                            id={`flexCheckIndeterminate-${item?.id}`}
                            onClick={(event) => handleChange(event, item?.id)}
                            checked={item?.checked}
                          />

                          <label
                            className="form-check-label fw-bold"
                            htmlFor={`flexCheckIndeterminate-${item?.id}`}
                          >
                            {item?.order_display_id}
                          </label>
                        </div>
                      </td>
                      <td className="flex-1  p-1 fw-bold text-left  word-break text-primary">
                        <div className="text-break ">
                          <SoftBadge bg="primary" className="me-2">
                            {item?.status}
                          </SoftBadge>
                        </div>
                      </td>
                      <td
                        className="flex-1  px-1 text-left fw-bold  text-break text-primary"
                        style={{ flex: "1" }}
                      >
                        {getFormattedDate(item?.created_at)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <div className="text-center border  border-top-0 p-3 rounded-bottom text-secondary">
                  Data not found
                </div>
              )}
            </div>
          </table>
        </div>
      </div>
    </div>
  );
}

export default OrderManagementTable;
